import config from '../config/config';
import { dateFormatOptions } from '../config/filterTypes';
import moment from 'moment';
import { getState } from '../config/store';
import 'moment-timezone';
import { domesticKey, globalKey } from 'Cache';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';

export const reFlowCharts = () => {
  setTimeout(() => {
    Highcharts.charts.forEach(chart => chart?.reflow());
    Highstock.charts.forEach(chart => chart?.reflow());
  }, [700]);
};

export const createHash = function(str, seed = 0) {
  let h1 = 0xdeadbeef ^ seed,
    h2 = 0x41c6ce57 ^ seed;
  for (let i = 0, ch; i < str.length; i++) {
    ch = str.charCodeAt(i);
    h1 = Math.imul(h1 ^ ch, 2654435761);
    h2 = Math.imul(h2 ^ ch, 1597334677);
  }
  h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
  h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);
  return 4294967296 * (2097151 & h2) + (h1 >>> 0);
};

export const setItemInLocalStorage = (key, value, isStringify = true) => {
  localStorage.setItem(key, isStringify ? JSON.stringify(value) : value);
};

export const getItemFromLocalStorage = (key, defaultValue, isParse = true) => {
  try {
    const value = localStorage.getItem(key);
    return (isParse ? JSON.parse(value) : value) ?? defaultValue;
  } catch (e) {
    console.log('getItemFromLocalStorage: ', e);
    return defaultValue;
  }
};
export const removeLocalStorage = () => {
  const keysToPreserve = [config.homepageGridLayoutKey, config.socialSentimentGridLayoutKey];

  Object.keys(localStorage).forEach(key => {
    if (!keysToPreserve.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const getComparisonDateFormat = () =>
  dateFormatOptions.find(d => d.value === getUserDateFormat())?.comparisonFormat || config.defaultComparisonDateFormat;

export const getUserDateFormat = () => getState().User.user?.date_format ?? config.defaultDateFormat;

export const changeDateFormatByTimezone = (dateStr, timeFormat, timeZone) => {
  if (!dateStr || !timeZone) return '';
  const format = timeFormat ? `${getUserDateFormat()} ${timeFormat}` : getUserDateFormat();
  return moment(dateStr).isValid()
    ? moment
        .utc(dateStr)
        .tz(timeZone)
        .format(format)
    : '';
};

export const changeDateFormat = (dateStr, timeFormat) => {
  if (!dateStr) return '';
  const format = timeFormat ? `${getUserDateFormat()} ${timeFormat}` : getUserDateFormat();
  return moment(dateStr).isValid() ? moment.utc(dateStr).format(format) : '';
  // why .utc? By creating a moment object in UTC timezone, we ensure that the date and time values are represented without any offsets for timezones. This will help to fix one day date difference for different time zones.
};

export const getSelectedRegionId = region => {
  // 1(Canada), 2(U.S) using in dashboard and domestic(U.S), global(Canada) using in Grid
  if (['domestic', 2].includes(region)) return 2;
  if (['global', 1].includes(region)) return 15;
};

export const getHumanReadableDateDuration = startDate => {
  if (moment(startDate).isValid) {
    return moment(startDate).fromNow();
  }
};

export const reloadScreenToRefreshData = () => {
  localStorage.removeItem(domesticKey); // this will help to update domestic IndexDb data
  localStorage.removeItem(globalKey); // this will help to update global IndexDb data
  window.location.reload();
};

export const getTickerByFlag = (ticker, flag) => {
  if (!ticker) return null;

  return parseInt(flag) === 15 ? `${ticker}.TO` : ticker;
};

export const downloadBlob = (blob, fileName) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
